import { createSlice } from "@reduxjs/toolkit";
import { SliceAction } from "store/store";

const queryParamsLS = JSON.parse(window.localStorage.getItem("adminCostsPage") || "{}");
const queryParamsURL = Object.fromEntries(new URLSearchParams(window.location.search));

const isActivePage = window.location.pathname.includes("statistics") && (queryParamsURL?.tab === "costs")

const initialState: {
    activePaginationPage: number,
    activeStartDate: string,
    activeEndDate: string,
    activeTagFilter: number
} = Object.assign(
    (isActivePage && Object.keys(queryParamsURL).some(item => ["page", "startDate", "endDate", "tagFilter"].includes(item)))
        ? {
            activePaginationPage: Number(queryParamsURL?.page || "1"),
            activeStartDate: queryParamsURL?.startDate || "",
            activeEndDate: queryParamsURL?.endDate || "",
            activeTagFilter: Number(queryParamsURL?.tagFilter || ""),
        }
        : {
            activePaginationPage: Number(queryParamsLS?.page || "1"),
            activeStartDate: queryParamsLS?.startDate || "",
            activeEndDate: queryParamsLS?.endDate || "",
            activeTagFilter: Number(queryParamsLS?.tagFilter || ""),
        }
);

window.localStorage.setItem("adminCostsPage", JSON.stringify({
    page: initialState.activePaginationPage,
    startDate: initialState.activeStartDate,
    endDate: initialState.activeEndDate,
    tagFilter: initialState.activeTagFilter,
}))

const costsSlice = createSlice({
    initialState,
    name: "costsAdminPage",
    reducers: {
        setActivePaginationPage(state, action: SliceAction<(typeof initialState)["activePaginationPage"]>) {
            window.localStorage.setItem("adminCostsPage", JSON.stringify({
                page: action.payload,
                startDate: state.activeStartDate,
                endDate: state.activeEndDate,
                tagFilter: state.activeTagFilter,
            }))
            state.activePaginationPage = action.payload;
        },
        setActiveStartDate(state, action: SliceAction<(typeof initialState)["activeStartDate"]>) {
            window.localStorage.setItem("adminCostsPage", JSON.stringify({
                page: state.activePaginationPage,
                startDate: action.payload,
                endDate: state.activeEndDate,
                tagFilter: state.activeTagFilter,
            }))
            state.activeStartDate = action.payload;
        },
        setActiveEndDate(state, action: SliceAction<(typeof initialState)["activeEndDate"]>) {
            window.localStorage.setItem("adminCostsPage", JSON.stringify({
                page: state.activePaginationPage,
                startDate: state.activeStartDate,
                endDate: action.payload,
                tagFilter: state.activeTagFilter,
            }))
            state.activeEndDate = action.payload;
        },
        setActiveTagFilter(state, action: SliceAction<(typeof initialState)["activeTagFilter"]>) {
            window.localStorage.setItem("adminCostsPage", JSON.stringify({
                page: state.activePaginationPage,
                startDate: state.activeStartDate,
                endDate: state.activeEndDate,
                tagFilter: action.payload,
            }))
            state.activeTagFilter = action.payload;
        }
    },
});

const { reducer, actions } = costsSlice;

export default reducer;

export const {
    setActivePaginationPage,
    setActiveEndDate,
    setActiveStartDate,
    setActiveTagFilter
} = actions;
